import { Injectable } from '@angular/core';
import { Action, State, Store } from '@ngxs/store';
import { MetadataControlActions } from '@medsurf/flat-actions';
import { ApiControlService } from '@medsurf/flat-services';
import { AuthControlState, MetadataEntityState } from '../../internal';

export interface MetadataControlStateModel {
  initialLoad: boolean;
}

@State<MetadataControlStateModel>({
  name: 'metadataControl',
  defaults: {
    initialLoad: false
  }
})
@Injectable()
export class MetadataControlState {
  constructor(public store: Store,
              public apiControlService: ApiControlService) {
  }

  //<editor-fold desc="Actions">

  @Action(MetadataControlActions.GetMetadata)
  getMetadata() {
    if (!this.store.selectSnapshot(MetadataEntityState.metadata)) {
      return this.apiControlService.sendMessage(
        new MetadataControlActions.GetMetadataRequest()
      );
    }
    return;
  }
  //</editor-fold>
}
